import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DATE_FIELD_CLASS_NAME = 'DateField';
export const DATE_FIELD_CLASS_SLOTS = ['root', 'loader'] as const;

export type DateFieldClassSlot = (typeof DATE_FIELD_CLASS_SLOTS)[number];

export interface DateFieldClasses {
	root: string;
	fullWidth: string;
	loader: string;
}

export type DateFieldClassKey = keyof DateFieldClasses;

export const getDateFieldUtilityClass = (slot: string) =>
	generateUtilityClass(DATE_FIELD_CLASS_NAME, slot);

export const dateFieldClasses: DateFieldClasses = generateUtilityClasses(
	DATE_FIELD_CLASS_NAME,
	['root', 'fullWidth', 'loader'],
);

export default dateFieldClasses;
